<template>
  <div class="password-expiry-wrap" v-if="userErrorInfo && userErrorInfo.expiry">
    <div class="password-expiry">
      <div class="msg-wrap">
        <div class="circle">
          <div class="before"></div>
          <div class="after"></div>
        </div>
        <div class="error-msg">
          <span class="expiry-error">Your password has expired.</span>
        </div>
        <div style="clear:both"></div>
      </div>
      <p class="redirect-text">
        We are redirecting to Change Password page in
        <strong>{{redirectTime}}</strong> seconds OR
        <a href="javascript:void(0)" @click="goToPage(userErrorInfo)">Click Here</a>
      </p>
    </div>
  </div>
</template>

<style>
    .password-expiry-wrap {
        margin-bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        position: fixed;
        z-index: 999;
        left: 0;
        top: 0;
    }

    .password-expiry {
        position: fixed;
        z-index: 99999;
        left: 0;
        right: 0;
        width: 555px;
        background: #fff;
        margin: 150px auto 0;
        border-radius: 2px;
        padding: 18px 20px;
    }

    .password-expiry .msg-wrap {
        display: table;
        margin: 0 auto;
    }

    .password-expiry h4 {
        margin-bottom: 30px;
    }
    .password-expiry .text-center {
        text-align: center;
    }
    .password-expiry .user-name {
        font-family: OpenSans-Regular;
    }
    .password-expiry .error-msg {
        margin-top: 5px;
        text-align: left;
        font-family: OpenSans-Regular;
        font-size: 16px;
        line-height: 18px;
        float: left;
        margin-left: 12px;
    }

    .password-expiry .error-msg .expiry-error {
        color: #ff0000;
        font-family: OpenSans-Semibold;
    }

    .password-expiry .redirect-text {
        text-align: center;
        font-family: OpenSans-Regular;
        margin-top: 18px;
        font-size: 15px;
    }
    .password-expiry .redirect-text a {
        font-family: OpenSans-Semibold;
        font-size: 15px;
    }

    .password-expiry .circle {
        float: left;
        width: 26px;
        height: 26px;
        position: relative;
        border-radius: 50%;
        margin: 0px auto;
        vertical-align: top;
        cursor: pointer;
        z-index: 2;
        border: 1px solid #ff0000;
        background: #ff0000;
    }
    .password-expiry .circle .before,
    .password-expiry .circle .after {
        content: "";
        position: absolute;
        width: 16px;
        height: 3px;
        background-color: #fff;
        border-radius: 0;
        top: 11px;
        z-index: 0;
    }

    .password-expiry .circle .before {
        left: 4px;
        -ms-transform: rotate(225deg);
        -webkit-transform: rotate(225deg);
        -moz-transform: rotate(225deg);
        transform: rotate(225deg);
    }

    .password-expiry .circle .after {
        -ms-transform: rotate(-225deg);
        -webkit-transform: rotate(-225deg);
        -moz-transform: rotate(-225deg);
        transform: rotate(-225deg);
        right: 4px;
    }

    @media screen and (max-width: 640px) {
        .password-expiry {
            width: 80%;
        }
    }

    @media screen and (max-width: 480px) {
        .password-expiry {
            width: 90%;
        }
    }
</style>

<script>
import umsinit from './../mixins/umsinit';
export default {
  name: "ChangePassword",
  props: ["userErrorInfo", 'redirectTime'],
  methods: {
    goToPage(info) {
        this.$emit('goToPage', info);
    }
}
};

</script>


// WEBPACK FOOTER //
// src/components/ChangePassword.vue